import React from 'react'

import PropertyWithTitle from './PropertyWithTitle'
// @ts-ignore
import RawFormattedMessage from './RawFormattedMessage'
import styles from './Status.module.css'
import { Status as ChauffeurStatus } from '../../types/Driver'
import { DocumentStatus } from '../../types/Docs'
import { Status as VehicleStatus } from '../../types/Vehicle'

interface StatusProps {
  status: ChauffeurStatus | DocumentStatus | VehicleStatus
}
interface StatusWithTitleProps extends StatusProps {
  isList?: boolean
}

export function Status ({ status }: StatusProps) {
  return (
    <span className={styles[status]}>
      <RawFormattedMessage id={`shared.status.${status}`} />
    </span>
  )
}

export function StatusWithTitle ({ isList, status }: StatusWithTitleProps) {
  return (
    <PropertyWithTitle isList={isList} title='shared.status'>
      <Status status={status} />
    </PropertyWithTitle>
  )
}

export default Status
